import { render, staticRenderFns } from "./TrainingSettingsModal.vue?vue&type=template&id=2ac384a8&scoped=true&"
import script from "./TrainingSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./TrainingSettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingSettingsModal.vue?vue&type=style&index=0&id=2ac384a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac384a8",
  null
  
)

export default component.exports